import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const PlansSection = styled.section`
  width: 100%;
  padding: 80px 20px;
  margin-top: 10px;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const PlansRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 32px;
  max-width: 1240px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`;

const PlanCard = styled.div`
  width: 391px;
  height: 432px;
  background: #FFFFFF;
  border: 2px solid #F8F8F8;
  box-shadow: 0px 12px 20px rgba(115, 115, 115, 0.05);
  border-radius: 8px;
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 360px;
    height: auto;
    padding: 24px;
    align-items: center;
    text-align: center;
  }
`;

const PlanTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const PlanIcon = styled.img`
  width: 32px;
  height: 32px;
`;

const PlanTitle = styled.h4`
  font-family: 'Montserrat', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  color: #000;
`;

const PlanFeatures = styled.ul`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  color: #606060;
  padding-left: 20px;
`;

const PlanPrice = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 35px;
  font-weight: 600;
  line-height: 43px;
  color: #000;
`;

const ActionButton = styled.button`
  width: 305px;
  height: 48px;
  background: linear-gradient(270deg, #1B1B84 -0.16%, #2AAE3F 99.84%);
  box-shadow: inset 0px -4px 10px rgba(3, 80, 68, 0.16);
  border-radius: 100px;
  border: none;
  color: #FFFFFF;
  font-family: 'Calmetta', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  cursor: pointer;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 28px;
  width: 375px;
  height: 404px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 360px;
    height: auto;
    align-items: center;
    text-align: center;
  }
`;

const InfoTitle = styled.h3`
  width: 366px;
  font-family: 'Montserrat', sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 37px;
  color: #000;

  @media (max-width: 768px) {
    font-size: 24px;
    width: auto;
  }
`;

const InfoDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

const InfoItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const InfoIcon = styled.img`
  width: 32px;
  height: 33px;
  border-radius: 8px;
`;

const InfoText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #5C5C5C;
`;

function Plans() {
  const location = useLocation();

  const handleRedirectIndividual = () => {
    window.open('https://www.cartaonacaosaude.com.br/individual', "_blank");
  };

  return (
    <PlansSection id="planos">
      <PlansRow>

        {/* Plano Individual */}
        <PlanCard>
          <PlanTitleRow>
            <PlanIcon src="/images/individual.png" alt="Ícone plano individual" />
            <PlanTitle>Plano Individual</PlanTitle>
          </PlanTitleRow>
          <PlanFeatures>
            <li>Telemedicina 24h</li>
            <li>Consultas e exames com desconto</li>
            <li>Seguros inclusos</li>
            <li>Acesso ao Clube de Vantagens</li>
          </PlanFeatures>
          <PlanPrice>R$ 49,90</PlanPrice>
          <ActionButton onClick={handleRedirectIndividual}>
            Contratar agora
          </ActionButton>
        </PlanCard>

        {/* Plano Familiar */}
        <PlanCard>
          <PlanTitleRow>
            <PlanIcon src="/images/emgrupo.png" alt="Ícone plano familiar" />
            <PlanTitle>Plano Familiar</PlanTitle>
          </PlanTitleRow>
          <PlanFeatures>
            <li>Todos os benefícios</li>
            <li>Inclusão de dependentes</li>
            <li>Suporte saúde emocional e familiar</li>
            <li>Suporte saúde pet</li>
          </PlanFeatures>
          <PlanPrice>R$ 157,90</PlanPrice>
          <ActionButton onClick={() => window.open('https://www.cartaonacaosaude.com.br/familiar', "_blank")}>
            Contratar agora
          </ActionButton>
        </PlanCard>

        {/* Box Informativo */}
        <InfoBox>
          <InfoTitle>Todos os serviços que sua família precisa</InfoTitle>
          <InfoDetails>
            <InfoItem>
              <InfoIcon src="/images/certo.png" alt="Consultas e exames" />
              <InfoText>Consultas e exames com desconto</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoIcon src="/images/certo.png" alt="Farmácias com desconto" />
              <InfoText>Farmácias com até 35% off</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoIcon src="/images/certo.png" alt="Telemedicina 24h" />
              <InfoText>Telemedicina Einstein 24h incluída</InfoText>
            </InfoItem>
            <InfoItem>
              <InfoIcon src="/images/certo.png" alt="Clube de vantagens" />
              <InfoText>Clube de Vantagens e suporte pet</InfoText>
            </InfoItem>
          </InfoDetails>
        </InfoBox>

      </PlansRow>
    </PlansSection>
  );
}

export default Plans;
